import React, { useState } from 'react';
import { MdClose, MdOutlineFileUpload } from 'react-icons/md';
import Modal from '../../components/modal';
import Input from '../../components/Input';
import Button from '../../components/Button';
import { toast } from 'react-toastify';
import axios from 'axios';
import AssignTeachers from '../AssignTeachers';

const AddStudents = ({ isModalOpen, setIsModalOpen, closeModal }) => {
  const [planData, setPlanData] = useState({
    teacherName: '',
    fatherName: '',
    qualification: '',
    address: '',
    email: '',
    whatsappNo: '',
    phoneNo: '',
    password: '',
    image: null,
    timeSlots: [{ startTime: '', endTime: '' }]
  });
  const [loading, setLoader] = useState(false);
  const [isEmailChecked, setIsEmailChecked] = useState(false);
  const [image, setImage] = useState('');
  const [isCheckingEnrollment, setIsCheckingEnrollment] = useState(false);
  const [isEmailRegistered, setIsEmailRegistered] = useState(false);
  const [student, setStudent] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setPlanData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setPlanData((prev) => ({ ...prev, image: file }));
    setImage(file);
  };

  const handleRemoveImage = () => {
    setPlanData((prev) => ({ ...prev, image: null }));
  };

  const checkEnrollmentStatus = async () => {
    const email = planData.email;
    if (!email) {
      toast.error('Please enter an email address');
      return;
    }

    setIsCheckingEnrollment(true);

    const params = {
      email: email
    };

    try {
      const res = await axios.post(
        `https://quran-backend-theta.vercel.app/v1/user/user-by-email`,
        params
      );
      console.log(res);

      if (res?.data?.success === true) {
        setIsEmailRegistered(true);
        setStudent(res?.data?.data);
      } else {
        setIsEmailRegistered(false);
        setStudent(res?.data?.data);
      }
      setIsEmailChecked(true); // Set isEmailChecked to true after checking
    } catch (error) {
      console.log(error);
      toast.error('Error checking email');
    } finally {
      setIsCheckingEnrollment(false);
    }
  };

  const bannerSubmit = async (e) => {
    e.preventDefault();

    if (!isEmailChecked) {
      toast.error('Please check the email first');
      return;
    }

    if (isEmailRegistered) {
      toast.error('Email is already registered');
      return;
    }

    setLoader(true);
    const formdata = new FormData();
    formdata.append('images', image);

    try {
      const uploadResponse = await fetch('https://file-upload-ashen.vercel.app/api/upload', {
        method: 'POST',
        body: formdata
      });
      const uploadResult = await uploadResponse.json();

      if (uploadResult?.success) {
        const myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');

        const raw = JSON.stringify({
          name: planData.teacherName,
          email: planData.email,
          password: planData.password,
          fatherName: planData.fatherName,
          qualification: planData.qualification,
          address: planData.address,
          whatsappNumber: planData.whatsappNo,
          phoneNumber: planData.phoneNo,
          cnic: uploadResult.data[0],
          photo: 'htt',
          role: 'student',
          timeSlots: planData.timeSlots
        });

        const registerResponse = await fetch(
          'https://quran-backend-theta.vercel.app/v1/user/register',
          {
            method: 'POST',
            headers: myHeaders,
            body: raw
          }
        );
        const registerResult = await registerResponse.json();

        if (registerResult?.success) {
          setLoader(false);
          location.reload();
        } else {
          setLoader(false);
          toast.error(registerResult.error);
        }
      } else {
        setLoader(false);
        toast.error('Error In Uploading Image...');
      }
    } catch (error) {
      setLoader(false);
      toast.error(error);
    }
  };

  const isFormValid = () => {
    const {
      teacherName,
      fatherName,
      qualification,
      address,
      email,
      whatsappNo,
      phoneNo,
      password,
      image,
      timeSlots
    } = planData;
    return (
      teacherName.trim() !== '' &&
      fatherName.trim() !== '' &&
      qualification.trim() !== '' &&
      address.trim() !== '' &&
      email.trim() !== '' &&
      whatsappNo.trim() !== '' &&
      phoneNo.trim() !== '' &&
      password.trim() !== '' &&
      image !== null &&
      timeSlots.every((slot) => slot.startTime.trim() !== '' && slot.endTime.trim() !== '')
    );
  };

  const [assign, setAssign] = useState(false);

  return (
    <div>
      <AssignTeachers getData={student} setIsModalOpen={setAssign} isModalOpen={assign} />
      <Modal isOpen={isModalOpen} onClose={closeModal} className={'rounded-md'}>
        <div className="">
          <div className="p-3 flex justify-between items-center">
            <div></div>
            <h1 className="capitalize h4 font-medium">Add Student</h1>
            <MdClose onClick={() => setIsModalOpen(false)} size={25} />
          </div>
          <hr />
          <div className="p-5">
            <form onSubmit={bannerSubmit}>
              <div className="flex gap-5 flex-wrap">
                <div className="md:w-[48%] w-full">
                  <Input
                    label={'Teacher Name'}
                    name="teacherName"
                    placeholder={'name'}
                    className={'bg-gray-100 px-2 w-full'}
                    value={planData.teacherName}
                    onChange={handleChange}
                  />
                </div>
                <div className="md:w-[48%] w-full">
                  <Input
                    label={'Father Name'}
                    name="fatherName"
                    placeholder={'Father Name'}
                    className={'bg-gray-100 px-2 w-full'}
                    value={planData.fatherName}
                    onChange={handleChange}
                  />
                </div>
                <div className="md:w-[48%] w-full">
                  <Input
                    label={'Qualification'}
                    name="qualification"
                    placeholder={'Qualification'}
                    className={'bg-gray-100 px-2 w-full'}
                    value={planData.qualification}
                    onChange={handleChange}
                  />
                </div>
                <div className="md:w-[48%] w-full">
                  <Input
                    label={'Address'}
                    name="address"
                    placeholder={'Address'}
                    className={'bg-gray-100 px-2 w-full'}
                    value={planData.address}
                    onChange={handleChange}
                  />
                </div>
                <div className="md:w-[48%] w-full">
                  <Input
                    label={'Email Address'}
                    name="email"
                    placeholder={'Email Address'}
                    className={'bg-gray-100 px-2 w-full'}
                    value={planData.email}
                    onChange={handleChange}
                  />
                  <Button
                    label="Check"
                    type="button"
                    className="bg-secondary mt-3 text-white py-1 w-full"
                    onClick={checkEnrollmentStatus}
                    disabled={isCheckingEnrollment}
                  />
                  {isEmailChecked && isEmailRegistered && (
                    <p className="text-red-500 text-sm mt-2">Email is already registered.</p>
                  )}
                </div>
                <div className="md:w-[48%] w-full">
                  <Input
                    label={'WhatsApp No'}
                    name="whatsappNo"
                    placeholder={'WhatsApp No'}
                    className={'bg-gray-100 px-2 w-full'}
                    value={planData.whatsappNo}
                    onChange={handleChange}
                  />
                </div>
                <div className="md:w-[48%] w-full">
                  <Input
                    label={'Phone No'}
                    name="phoneNo"
                    placeholder={'Phone No'}
                    className={'bg-gray-100 px-2 w-full'}
                    value={planData.phoneNo}
                    onChange={handleChange}
                  />
                </div>
                <div className="md:w-[48%] w-full">
                  <Input
                    label={'Password'}
                    name="password"
                    placeholder={'Password'}
                    className={'bg-gray-100 px-2 w-full'}
                    value={planData.password}
                    onChange={handleChange}
                  />
                </div>

                {/* Image upload section */}
                <div
                  className="w-full border-dashed border-[#9E9E9E] bg-[#fafafa] border-2 rounded-lg p-4 cursor-pointer"
                  onClick={() => document.getElementById('fileInput').click()}
                >
                  <div className="bg-[#F6F6F6] mx-auto w-14 flex justify-center items-center h-14 rounded-2xl">
                    <MdOutlineFileUpload size={30} className="text-primary" />
                  </div>
                  <p className="text-primary font-medium mt-3 text-center">
                    <span className="text-secondary">Click here</span> to upload or drop CNIC
                  </p>
                  <input
                    id="fileInput"
                    type="file"
                    style={{ display: 'none' }}
                    onChange={handleImageChange}
                  />
                </div>

                {/* Image preview */}
                {planData.image && (
                  <div className="mt-4 relative">
                    <img
                      src={URL.createObjectURL(planData.image)}
                      alt="Selected"
                      className="w-full h-auto rounded-md"
                    />
                    <MdClose
                      onClick={handleRemoveImage}
                      className="absolute top-2 right-2 text-white cursor-pointer"
                      size={30}
                    />
                  </div>
                )}
              </div>

              {loading ? (
                <button
                  disabled
                  type="button"
                  className="bg-[#FB5722] w-full text-center mt-3 py-2.5 rounded-lg text-white uppercase font-semibold cursor-pointer"
                >
                  <svg
                    aria-hidden="true"
                    role="status"
                    className="inline w-4 h-4 me-3 text-white animate-spin"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="#E5E7EB"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentColor"
                    />
                  </svg>
                  Loading...
                </button>
              ) : (
                <div className="flex justify-center pt-5">
                  {isEmailRegistered ? (
                    <Button
                      label="Next"
                      type="button"
                      className="bg-secondary mt-3 text-white py-2.5 w-full"
                      onClick={() => {
                        setAssign(true);
                        setIsModalOpen(false);
                      }}
                    />
                  ) : (
                    <Button
                      label="Register"
                      type="submit"
                      className="bg-secondary mt-3 text-white py-2.5 w-full"
                      disabled={!isFormValid() || !isEmailChecked || isEmailRegistered}
                    />
                  )}
                </div>
              )}
            </form>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AddStudents;
